// Free publishing is a separate server capability, never a plan-name or
// payment-status shortcut. Missing/malformed responses retain existing gates.
export function freePublishingState(entitlements) {
  const value = entitlements?.freePublishing;
  if (value?.active !== true || value.manualDrafts !== true || value.ownMedia !== true
    || value.aiGeneration !== false) return null;
  const { limits, usage } = value;
  const count = number => Number.isSafeInteger(number) && number >= 0;
  if (!limits || !usage || !count(limits.socialAccounts) || !count(limits.successfulPublicationsMonthly)
    || ![usage.limit, usage.published, usage.reserved, usage.remaining].every(count)
    || usage.limit !== limits.successfulPublicationsMonthly
    || usage.remaining !== Math.max(0, usage.limit - usage.published - usage.reserved)
    || !Number.isFinite(Date.parse(usage.resetAt))
    || !Number.isFinite(Date.parse(usage.period?.periodStart))
    || !Number.isFinite(Date.parse(usage.period?.periodEnd))) return null;
  return value;
}

export function freePublishingCanDispatch(entitlements) {
  return (freePublishingState(entitlements)?.usage.remaining || 0) > 0;
}
